"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compatibleMfuMfdTypes = void 0;
exports.compatibleMfuMfdTypes = {
    FULL: ['SSR', 'MCO', 'PSY'],
    HDJ: ['SSR', 'MCO', 'PSY', 'USLD', 'UHCD', 'EHPAD', 'DC', 'DHC', 'CHIM', 'RC', 'RHC', 'HAD', 'MR'],
    HAD: ['SSR', 'MCO', 'PSY', 'USLD', 'UHCD', 'EHPAD', 'DC', 'DHC', 'CHIM', 'RC', 'RHC', 'HAD', 'MR'],
    MDV: ['SSR', 'MCO', 'PSY', 'USLD', 'UHCD', 'EHPAD', 'DC', 'DHC', 'CHIM', 'RC', 'RHC', 'HAD', 'MR'],
    EHPAD: ['EHPAD', 'USLD'],
    DC: ['DC'],
    RC: ['RC'],
    CHIM: ['CHIM'],
    URG: ['UHCD'],
    EPA: ['SSR', 'MCO', 'PSY'],
};
//# sourceMappingURL=medical-facility-unit.js.map